/*-
 * #%L
 * Aires Éducatives
 * %%
 * Copyright (C) 2020 - 2023 OFB
 * %%
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 * #L%
 */
import { FeedbackDTO } from "@/model/bean/GeneratedDTOs"
import { AbstractTypedRestService } from "@/services/rest/AbstractTypedRestService"

export class ToastParameter {
  message: string
  type = "is-info" // Par défaut, une couleur d'information
  position:
    | "is-top-right"
    | "is-top"
    | "is-top-left"
    | "is-bottom-right"
    | "is-bottom"
    | "is-bottom-left"
    | undefined = "is-bottom-right" // Par défaut, affichage en haut
  duration = 3000 // Durée de 3s, infini si -1
  indefinite = false // Par défaut, non indéfini
  "pause-on-hover" = true

  constructor(init?: Partial<ToastParameter>) {
    if (init) {
      Object.assign(this, init)

      if (init?.duration && init?.duration < 0) {
        this.indefinite = true
      }
    }
  }
}

export class FeedbackService extends AbstractTypedRestService<FeedbackDTO> {
  static INSTANCE = new FeedbackService()

  async sendFeedback(feedback: FeedbackDTO): Promise<FeedbackDTO> {
    return super.typedPutV2("/feedback", 2, feedback)
  }
}
